import React from 'react';
import {WineInfoAB} from '../../components/modules/accordion/WineInfo';
import {WineTerroirAB} from '../../components/modules/accordion/WineTerroir';
import {WineCellerAB} from '../../components/modules/accordion/WineCeller';
import {WineEttColtAB} from '../../components/modules/accordion/WineEttColt';
import {WineBottlesAB} from '../../components/modules/accordion/WineBottles';
import './abruzzo.scss'

function Abruzzo({data}) {

  return (
    <>
      {data[0] && <WineInfoAB />}
      {data[1] && <WineTerroirAB />}
      {data[2] && <WineCellerAB />}
      {data[3] && <WineEttColtAB />}
      {data[4] && <WineBottlesAB />}
    </>
  )
}
export default Abruzzo; 
